// The Borenius AI product mark: a flat brand-red rounded tile with a white "B"
// in GT Walsheim Pro Regular. The glyph is the real outline traced from the
// typeface (viewBox 100×100, corner radius 23% per the Ribbon Logo spec) so it
// never depends on a loaded font — identical at every size and surface. Keep
// this the single source of the mark; the plugin ribbon PNGs and app/icon.svg
// are rasterised from the same artwork.
//
// tone="red" (default): red tile, white B — the primary mark.
// tone="inverted": white tile, red B — for use on a solid red surface (login
// brand panel) where a red tile would disappear.

// The GT Walsheim Pro Regular "B" outline (font units, placed by the transform).
const B_GLYPH =
	"M160 0V1434H649Q749 1434 827.0 1409.5Q905 1385 952.5 1346.5Q1000 1308 1031.0 1256.0Q1062 1204 1073.5 1154.0Q1085 1104 1085 1051Q1085 926 1009.0 837.5Q933 749 829 727Q872 724 918.0 700.0Q964 676 1004.0 635.5Q1044 595 1070.0 532.5Q1096 470 1096 397Q1096 344 1083.5 292.5Q1071 241 1038.5 187.0Q1006 133 957.5 92.5Q909 52 829.5 26.0Q750 0 651 0ZM346 168H659Q726 168 776.5 189.0Q827 210 855.0 245.0Q883 280 896.0 319.5Q909 359 909 403Q909 441 895.0 480.5Q881 520 853.5 556.5Q826 593 776.5 616.0Q727 639 664 639H346ZM346 809H653Q719 809 769.0 830.5Q819 852 846.0 887.0Q873 922 886.0 959.5Q899 997 899 1036Q899 1067 891.5 1097.5Q884 1128 865.5 1159.0Q847 1190 819.5 1213.5Q792 1237 748.0 1251.5Q704 1266 649 1266H346Z";

export function BrandMark({
	size = 28,
	tone = "red",
	title = "Borenius AI",
	decorative = false,
	className,
}: {
	size?: number;
	tone?: "red" | "inverted";
	title?: string;
	// Decorative uses (e.g. the assistant avatar repeated per turn) hide the mark
	// from assistive tech so it isn't announced over and over. CSS width/height
	// from `className` (e.g. h-[26px]) override the intrinsic `size`.
	decorative?: boolean;
	className?: string;
}) {
	const tile = tone === "inverted" ? "#ffffff" : "#d7142e";
	const glyph = tone === "inverted" ? "#d7142e" : "#ffffff";
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 100 100"
			role={decorative ? undefined : "img"}
			aria-label={decorative ? undefined : title}
			aria-hidden={decorative || undefined}
			className={className}
		>
			{decorative ? null : <title>{title}</title>}
			<rect width="100" height="100" rx="23" fill={tile} />
			<path
				transform="translate(30.0739 72.75) scale(0.031729 -0.031729)"
				fill={glyph}
				d={B_GLYPH}
			/>
		</svg>
	);
}
